import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-trial-expired',
    templateUrl: './trial-expired.component.html',
    standalone: false
})
export class TrialExpiredComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
